import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cbfe8f50"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  style: {"display":"none"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("symbol", {
  id: "check-circle-fill",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "alert alert-success p-2 mt-1 mb-1 d-flex align-items-start",
  role: "alert"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "bi flex-shrink-0 me-2",
    width: "24",
    height: "24",
    role: "img",
    "aria-label": "Success:"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#check-circle-fill" })
  ])
], -1))
const _hoisted_6 = { class: "ms-1 me-1 flex-grow-1" }




export default /*#__PURE__*/_defineComponent({
  __name: 'SuccessModal',
  props: {
    active: { type: Boolean }
  },
  emits: ['reset'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3)),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (__props.active)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "aria-label": "Close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reset')))
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 64))
}
}

})